import { useMemo } from "react"
import { useSelector } from "react-redux"

import WorkersCompDrawerServiceItem from "./WorkersCompDrawerServiceItem"
import WorkersCompDrawerSurgicalItem from "./WorkersCompDrawerSurgicalItem"

import classes from './WorkersCompDepartments.module.css'

export default function WorkersCompDrawer({departmentId, workerCompData}) {
    const activeCase = useSelector(state => state.case.activeCase)
    const surgeries = activeCase?.surgeries ?? []
    const relatedServices = useMemo(() => {
        if (!departmentId) {
            return []
        }
        const services = activeCase?.services ?? []
        return services.filter((element) => element.department_id === departmentId)
    }, [departmentId, activeCase?.services])


    return <div>
        {departmentId !== 5 && <>
            {relatedServices.length > 0 && <div className={classes.drawer_container}>
                <table>
                    <thead>
                        <tr>
                            <td>Service</td>
                            {(departmentId === 1 || departmentId === 2) && <td>No. of visits</td>}
                            <td>Request Date</td>
                            <td>Status</td>
                            <td>Auth Date</td>
                            <td>Auth Exp. Date</td>
                            <td>Outside</td>
                            <td>Clinic</td>
                            <td>Provider</td>
                        </tr>
                    </thead>
                    <tbody>
                        {relatedServices.map(item => (
                            <WorkersCompDrawerServiceItem key={item.id} serviceItem={item} departmentId={departmentId} workerCompData={workerCompData}/>
                        ))} 
                    </tbody>
                </table>
                
            </div>}
            {relatedServices.length === 0 && <p>There are no services for this department!</p>}
        </>}
        
        {departmentId === 5 && <>
            {surgeries.length > 0 &&<div className={classes.drawer_container}>
                <table>
                    <thead>
                        <tr>
                            <td>Surgery</td>
                            <td>Step</td>
                            <td>Request Date</td>
                            <td>Status</td>
                            <td>Auth Date</td>
                            <td>Auth Exp. Date</td>
                            <td>Outside</td>
                            <td>Practice Type</td>
                            <td>Outside Clinic</td>
                        </tr>
                    </thead>
                    <tbody>
                        {surgeries.map((item) => (
                            <WorkersCompDrawerSurgicalItem key={item.id} surgicalItem={item} departmentId={departmentId} workerCompData={workerCompData} />
                        ))}  
                    </tbody>
                </table>
                
            </div>}
            {surgeries.length === 0 && <p>There are no surgeries!</p>}
        </>}
    </div>
}